define('home/views/SettingsUserBlockingNavView',[
    'backbone-marionette',

    'home/templates/settingsBlockingButtons',
], function (
    Marionette,

    settingsBlockingButtonsTemplate
) {
    'use strict';

    return Marionette.ItemView.extend({
        events: {
            'click [data-action=prev-page]': 'prevPage',
            'click [data-action=next-page]': 'nextPage',
        },

        template: settingsBlockingButtonsTemplate,

        initialize: function () {
            this.listenTo(this.collection, 'remove sync', this.render);
        },

        templateHelpers: function () {
            return {
                hasNext: this.collection.hasNext(),
                hasPrev: this.collection.hasPrev(),
            };
        },

        prevPage: function (evt) {
            evt.preventDefault();
            this.collection.prev();
        },

        nextPage: function (evt) {
            evt.preventDefault();
            this.collection.next();
        },
    });
});

